import React from 'react'
import injectStyles from 'react-jss'
import { useDispatch } from 'react-redux'

import StatsPage from 'Components/Page/StatsPageWrapper'
import UploadFile from './UploadFile'
import { showReduxModal } from '../../Reducers/UI/actions'
import { styles } from './styles'
import MailSpeedGraph from './Charts/MailSpeedGraph'
import MailDistributionGraph from './Charts/MailDistributionGraph'
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator'
import { getCampaignsDeliverabilityReport } from './gql'
import useGraphQLFetch from '../../Utils/Hooks/useGraphQLFetch'

const StatsDeliverability = ({
  classes,
  campaignResults: {
    id: campaignId,
    country: { code },
    deliverabilityReport: { id: deliverabilityReportId },
  },
}) => {
  const {
    data: deliverabilityReport,
    isLoaded,
    isError,
    errorMessage,
  } = useGraphQLFetch({
    fetchFn: getCampaignsDeliverabilityReport,
    defaultFetchArgs: campaignId,
    mapResponse: data => data.campaign.deliverabilityReport,
  })
  const dispatch = useDispatch()

  const showReduxModalHandle = () => {
    dispatch(
      showReduxModal({
        title: 'Upload Deliverability Report',
        children: (
          <UploadFile campaignDeliverabilityId={deliverabilityReportId} />
        ),
        hideButtons: true,
      }),
    )
  }

  return (
    <StatsPage>
      <div className={classes.uploadFile}>
        <span onClick={showReduxModalHandle}>Upload postage report</span>
      </div>
      {isLoaded ? (
        isError ? (
          `File was corrupted. Please, upload new file. 
          Error: ${errorMessage}`
        ) : (
          <div>
            <MailSpeedGraph deliverabilityReport={deliverabilityReport} />
            {code === 'US' ? (
              <MailDistributionGraph
                deliverabilityReport={deliverabilityReport}
              />
            ) : null}
          </div>
        )
      ) : (
        <LoadingIndicator />
      )}
    </StatsPage>
  )
}

export default injectStyles(styles)(StatsDeliverability)
